import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { LiveStreamWrapperRoutingModule } from './live-stream-wrapper-routing.module';
import { LiveStreamWrapperComponent } from './live-stream-wrapper.component';

@NgModule({
    imports: [LiveStreamWrapperRoutingModule, SharedModule],
    declarations: [LiveStreamWrapperComponent],
})
export class LiveStreamWrapperModule {
    static entry = LiveStreamWrapperComponent;
}
